import { PLATFORM_MARKETPLACE_FEE_PER_SIDE } from '../config/constants';

const roundUsd = (n) => Math.round(Number(n) * 100) / 100;

export const computeMarketplaceTradeFees = (pricePerShare, shares = 1) => {
  const trade = roundUsd(Number(pricePerShare) * shares);
  const buyerFeeUsd = roundUsd(trade * PLATFORM_MARKETPLACE_FEE_PER_SIDE);
  const sellerFeeUsd = roundUsd(trade * PLATFORM_MARKETPLACE_FEE_PER_SIDE);
  return {
    tradeAmountUsd: trade,
    buyerFeeUsd,
    sellerFeeUsd,
    buyerPaysUsd: roundUsd(trade + buyerFeeUsd),
    sellerReceivesUsd: roundUsd(trade - sellerFeeUsd),
  };
};

export const isMarketplaceListingAvailable = (listing) =>
  Boolean(
    listing
    && (!listing.status || listing.status === 'active')
    && Number(listing.shares) > 0
  );

/** Active API listings replace stale local copies; demo samples fill empty slots only. */
export const mergeMarketplaceListingsFromApi = (apiRows, demoRows = []) => {
  const activeApi = (Array.isArray(apiRows) ? apiRows : []).filter(isMarketplaceListingAvailable);
  const apiIds = new Set(activeApi.map((l) => String(l.id)));
  const demoOnly = (Array.isArray(demoRows) ? demoRows : []).filter(
    (l) => l?.id != null && !apiIds.has(String(l.id)) && isMarketplaceListingAvailable(l)
  );
  return [...activeApi, ...demoOnly];
};
